export var AppConfigActions;
(function (AppConfigActions) {
    AppConfigActions["SET_APP_THEME"] = "SET_APP_THEME";
})(AppConfigActions || (AppConfigActions = {}));
export function setAppTheme(theme) {
    return { type: AppConfigActions.SET_APP_THEME, payload: theme };
}
